import axios from '@/assets/js/axios.js'
import { GROUP_LABEL_API } from './apis'
// 获取分组标签列表
export function groupList (params) {
  return axios({
    url: GROUP_LABEL_API.QUERY,
    method: 'post',
    data: params
  })
}
// 获取引导页列表
export function addGroup (params) {
  return axios({
    url: GROUP_LABEL_API.ADD,
    method: 'post',
    data: params
  })
}
// 启用/禁用
export function isDel (params) {
  return axios({
    url: GROUP_LABEL_API.DELETE,
    method: 'post',
    data: params
  })
}
// 启用/禁用
export function isUse (params) {
  return axios({
    url: GROUP_LABEL_API.DISABLE,
    method: 'post',
    data: params
  })
}
// 根据ID获取引导页详情
export function groupDetail (params) {
  return axios({
    url: GROUP_LABEL_API.DETAIL,
    method: 'post',
    data: params
  })
}
// 更新
export function editGroup (params) {
  return axios({
    url: GROUP_LABEL_API.UPDATE,
    method: 'post',
    data: params
  })
}
